import { useEffect } from 'react';

const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Kalam:wght@400;700&display=swap';

/**
 * The landing pages' faces: Plus Jakarta Sans for the page, Kalam for the
 * handwritten sample working. Loaded only when a landing page mounts, so the
 * apps themselves pay nothing; the CSS falls back to system fonts until (or
 * unless) they arrive.
 */
export function useFrontDoorFonts(): void {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (document.querySelector(`link[data-front-door-fonts]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONT_HREF;
    link.setAttribute('data-front-door-fonts', '');
    document.head.appendChild(link);
  }, []);
}
